import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import { createSharedInputStyles } from "../sharedInputStyles";
import type { InputFieldSize } from "../sharedInputTypes";

export const StyledInputBase = styled(InputBase, {
  // Added the `shouldForwardProp` option to the styled function.
  // This tells MUI to not forward the size prop to the underlying DOM element, preventing the console warning.
  shouldForwardProp: (prop) => prop !== "$size",
})<{ size?: InputFieldSize; $size?: InputFieldSize }>(({ theme, size, $size }) => ({
  ...createSharedInputStyles(theme, size || $size),

  "> svg:first-of-type": {
    width: theme.spacing(5), // 45px equivalent
  },

  "& .MuiInputBase-input": {
    ...createSharedInputStyles(theme, size || $size)["& .MuiInputBase-input"],

    // [theme.breakpoints.up("sm")]: {
    //   maxWidth: theme.spacing(15), // 120px equivalent
    //   "&:focus": {
    //     maxWidth: theme.spacing(25), // 200px equivalent
    //   },
    // },
  },
}));
